export default "__VITE_ASSET__C9g1pVr0__"